module.exports = __webpack_public_path__ + "static/1-741f6004aa73a1a572a8f70cfd9b46fb.png";